import classNames from 'classnames';
import { PropsWithChildren } from 'react';

type Props = {
    heading?: string;
    backgroundsurface?: SupportedBackgroundColor;
    textColor?: SupportedTextColor;
};

const ThreeWaysToShop = ({
    heading = 'Find your match however you prefer',
    backgroundsurface = 'bg-surface-100',
    textColor = 'text-default',
    children,
}: PropsWithChildren<Props>) => {
    return (
        <section className={classNames('px-4 py-10 md:py-20', backgroundsurface)}>
            <div className="max-w-1200 mx-auto md:w-7/12 lg:w-full">
                <h2 className="text-32 leading-40 font-poppins font-bold text-center text-link-visited py-4 md:text-40 md:leading-56 lg:text-48 lg:leading-64">
                    {heading}
                </h2>
                <div className="flex flex-col lg:flex-row gap-12 px-4 py-8 md:px-6 lg:py-16 lg:gap-6 md:w-10/12 md:mx-auto lg:w-full">
                    {children}
                </div>
            </div>
        </section>
    );
};

export default ThreeWaysToShop;
